import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";

import namakaLogo from "../../../../assets/img/clients/namaka-compliance.webp";

export default function NamakaComplianceAthena() {
    const caseStudy = new CaseStudyTemplate(
        "Namaka Compliance: Athena",
        (
            <div>
                <p>
                    DEV4 were engaged to enhance an existing SAAS Competence Management System (CMS) with Namaka Compliance.  The development roadmap for Athena future-proofs the system and adds value to its offerings, ensuring it keeps its competitive advantage.
                </p>
            </div>
        ),
        // Project Showcase Thumbnail
        "https://around.createx.studio/assets/img/portfolio/list/06.png",
        new Company(
            "Namaka Compliance",
            // Company Logo
            namakaLogo
        ),
        "https://www.namakacompliance.com/products/athena",
        [
            technologies.netCore,
            technologies.vueJS,
            technologies.sqlServer,
            technologies.azure
        ]
    )

    return (
        <CaseStudy caseStudy={caseStudy}></CaseStudy>
    )
}